// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient global.d.ts has no runtime JS counterpart to import
/// <reference path="./global.d.ts" />
import { logData } from "@jetblue/dotcom-fe-logger";
import { subscribeToUserConsentDecision } from "@jetblue/dotcom-trust-arc";

export const ensureDynamicYieldGlobal = () => {
  // eslint-disable-next-line unicorn/no-global-object-property-assignment -- 3rd party stuff
  const dy = (globalThis.DY ??= {});

  if (typeof dy.userActiveConsent?.accepted !== "boolean") {
    dy.userActiveConsent = { accepted: false };
  }

  return dy;
};
export const updateDynamicYieldConsent = (value: boolean) => {
  void logData({ message: "DY consent updated", newValue: value });
  ensureDynamicYieldGlobal().userActiveConsent = {
    accepted: value,
  };

  globalThis.DYO?.ActiveConsent.updateConsentAcceptedStatus(value);
};

const state = { isDynamicYieldRunning: false };

export const subscribeDynamicYieldConsent = () =>
  subscribeToUserConsentDecision((decision) => {
    const shouldRun = decision.functional === true;
    if (shouldRun === state.isDynamicYieldRunning) {
      return;
    }

    state.isDynamicYieldRunning = shouldRun;
    updateDynamicYieldConsent(shouldRun);
  }, "Dynamic Yield");
